var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1719107324261,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 10111,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 427.2c127.488 96.32 347.712 337.984 280.96 405.952A425.216 425.216 0 0 1 512 938.688a424.832 424.832 0 0 1-280.832-105.536C164.288 765.184 384.64 523.52 512 427.2z m286.784-221.696c3.456 0 6.848 0.512 10.048 1.664 1.28 0.448 2.304 0.96 2.88 1.472a424.896 424.896 0 0 1 126.976 303.488 424.64 424.64 0 0 1-94.656 267.904c50.048-92.352-127.168-353.792-216.064-459.072 100.288-99.968 149.76-115.456 170.88-115.456z m-573.504 0.064c20.928 0 70.592 15.36 170.88 115.392C307.2 426.24 130.048 687.36 179.904 779.968a424.96 424.96 0 0 1-94.656-267.84 425.088 425.088 0 0 1 126.848-303.424c0.192-0.064 1.024-0.768 3.072-1.536l4.992-1.28 5.056-0.32zM512 85.312c76.608 0 151.296 19.584 222.72 62.848l16.64 10.496-2.24-1.216a102.592 102.592 0 0 0-50.56-10.048c-54.528 1.92-116.736 23.296-186.56 64-69.76-40.64-131.968-62.08-186.432-64-28.928-1.024-47.68 8.32-52.864 11.328l-1.28 0.704c76.288-51.136 157.312-74.112 240-74.112z",
    "p-id": 10112,
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXbox);
export default __webpack_public_path__ + "static/media/xbox.1d2e9544989be122fb4c5194afbd71e0.svg";
export { ForwardRef as ReactComponent };